'use strict';

var dialog = require('_core_ext/dialog');

function initPopUpEvents () {
    $(document)
        .on('click', '[data-popup]', function (e) {
            e.preventDefault();

            var popupUrl,
                $el = $(e.currentTarget),
                customerType = $el.data('popup');

            switch (customerType) {
                case 'professional':
                    popupUrl = Urls.customerProfessional;
                    break;
                case 'student':
                    popupUrl = Urls.customerStudent;
                    break;
            }

            if (popupUrl) {
                dialog.open({
                    url: popupUrl,
                    options: {
                        closeOnEscape: false,
                        dialogClass: 'trade-card',
                        buttons: [{
                            text: Resources.APPLY_TRADE_CARD,
                            'class': 'trade-popup_button',
                            click: function () {
                                $(this).dialog('close');
                            }
                        }]
                    }
                });
            }
        });
}

module.exports = {
    init: function () {
        initPopUpEvents();
    }
};